<template>
	<div v-if="notSupported" class="height-100 flex-centerize">
		<h2 class="reg">Ply doesn't support Add-ons for this app yet.</h2>
	</div>
	<div v-else class="width-100 height-100">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between pt-7 pr-6">
			<div>
				<Row class="items-center">
					<AppIcon width="20" height="20" :name="titlePrefixIcon" v-if="titlePrefixIcon" class="mr-2" />
					<div class="title-text">{{ title }}</div>
				</Row>
				<div v-if="subTitle" class="description-text">{{ subTitle }}</div>
			</div>
			<div v-if="filterWorkflowsIds.length > 0" @click="clearFilter" class="clear-filter">Clear filter</div>
			<div class="display-flex flex-row flex-align-center">
				<router-link v-if="showButtonDropdowns" :to="toButtonDropdowns" class="reg pointer">Button dropdowns</router-link>
				<OpenInspirationCenterButton class="ml-3" v-if="isInspirationCenterEnabled" />
				<AnemicButton v-if="canCreateNew" @click="$emit('show-wizard')" class="new-button ml-6">New Feature</AnemicButton>
			</div>
		</div>
		<FlowsView :page="page" :filterBy="filterBy" :idsToShow="filterWorkflowsIds" class="width-100 height-100 flows-container" />
	</div>
</template>

<script>
import CreateAndManageService from '../AppLayout/ManageAndCreate/create-and-manage-service';
import OpenInspirationCenterButton from '@/components/dialogs/IdeaDialog/OpenInspirationCenterButton.vue';
import { BUTTON_DROPDOWN_ROUTE_NAME } from '@/router/router.const';
import { setShowInspirationCenter } from '@/store/modules/appLayout/actions';
import { isInspirationCenterEnabled } from '@/store/modules/featureFlags/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import FlowsView from '@/views/AppContentPages/FlowsView.vue';
export default {
	name: 'Features',
	props: {
		idsToShow: { type: Array },
		filterBy: { type: Object },
		subTitle: { type: String },
		titlePrefixIcon: { type: String },
		notSupported: { type: Boolean },
		page: { type: Number, default: 1 },
		showButtonDropdowns: { type: Boolean },
		canCreateNew: { type: Boolean, default: true },
		title: { type: String, default: 'Features' },
	},
	components: { FlowsView, OpenInspirationCenterButton },
	computed: {
		...mapGettersShorthand({ isInspirationCenterEnabled }),
		toButtonDropdowns() {
			return {
				...this.$route,
				name: CreateAndManageService.getPlacementModeRoutePrefix(this.$route) + BUTTON_DROPDOWN_ROUTE_NAME,
			};
		},
	},
	methods: {
		...mapActionsShorthand({ setShowInspirationCenter }),
		showInspirationCenter() {
			this.setShowInspirationCenter({ showInspirationCenter: true });
		},
		clearFilter() {
			this.filterWorkflowsIds = [];
		},
	},
	mounted() {
		this.filterWorkflowsIds = this.idsToShow;
	},
	data() {
		return {
			filterWorkflowsIds: [],
		};
	},
};
</script>

<style scoped lang="scss">
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: var(--fifth-color) !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.flows-container {
	padding-bottom: 90px;
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
	text-align: left;
	letter-spacing: 0px;
}
.clear-filter {
	font-size: 14px;
	opacity: 0.5;
	text-decoration: underline;
	cursor: pointer;
}
.pointer {
	cursor: pointer;
	font-size: 14px;
	color: #6762f0;
	font-weight: 400;
	text-decoration: underline;
}
</style>
